<template>
  <div class="pto-documents tw-p-4">
    <div class="tw-mb-4 tw-flex tw-flex-wrap tw-items-end tw-gap-4">
      <CustomSelect
        :options="residentOptions"
        label="ЖК"
        style="min-width: 200px;"
        optionValueKey="resident_id"
        optionLabelKey="resident_name"
        :value="filters.resident_id"
        @change="(v) => onFilterChange('resident_id', v)"
      />
      <!-- <CustomSelect
        :options="projectOptions"
        label="Проект"
        style="min-width: 220px;"
        optionValueKey="project_id"
        optionLabelKey="project_name"
        :value="filters.project_id"
        @change="(v) => onFilterChange('project_id', v)"
      /> -->
      <CustomSelect
        :options="ptoFloorOptions"
        label="Этаж"
        style="width: 100px;"
        optionValueKey="floor"
        optionLabelKey="floor_name"
        :value="filters.floor"
        @change="(v) => onFilterChange('floor', v)"
      />
      <!-- <CustomSelect
        :options="documentTypes"
        label="Тип"
        style="width: 200px;"
        optionValueKey="floor_map_document_type_id"
        optionLabelKey="floor_map_document_type_name"
        :value="filters.floor_map_document_type_id"
        @change="(v) => onFilterChange('floor_map_document_type_id', v)"
      /> -->
      <CustomSelect
        :options="ptoDocumentStatusOptions"
        label="Статус"
        style="min-width: 260px;"
        optionValueKey="status"
        optionLabelKey="status_name"
        :value="filters.status"
        @change="(v) => onFilterChange('status', v)"
      />
    </div>

    <NotFoundText v-if="assignmentsLoaded && !hasPtoAssignments" class="tw-my-8" />
    <CustomTable
      v-else
      title="Документы ПТО"
      :rowsData="rowsData"
      :columns="tableColumns"
      :stickyHeader="false"
      :loading="isFetching"
      :custom-body="true"
      :custom-header="true"
      :small="true"
    >
      <template #top-right>
        <div class="tw-flex tw-items-center tw-gap-2">
          <CustomButton
            :loading="acceptingBulk"
            :disable="selectedItems.length === 0 || acceptingRowId !== null"
            color="primary"
            size="sm"
            style="height: 36px; font-size: 14px;"
            @click="openConfirmBulkAccept"
          >
            Принять
          </CustomButton>
          <q-btn :loading="isFetching" color="primary" size="sm" style="height: 36px; font-size: 14px; border-radius: 8px;" @click="loadData">
            <q-icon name="replay" />
          </q-btn>
        </div>
      </template>
      <template #customHeader="props">
        <q-tr>
          <q-th auto-width>
            <q-checkbox
              :model-value="isAllSelected"
              :indeterminate="isIndeterminate"
              :disable="!rowsData.some((item) => !item.is_pto_checked)"
              @update:model-value="toggleSelectAll"
            />
          </q-th>
          <q-th v-for="col in props.cols" :key="col.name" :props="props">
            {{ col.label }}
          </q-th>
        </q-tr>
      </template>
      <template #customBody="props">
        <q-tr>
          <custom-table-cell align="center" vertical-align="center">
            <CustomCheckbox
              v-if="!props.row.is_pto_checked"
              :value="isItemSelected(props.row)"
              @change="(v) => toggleItem(props.row, v)"
            />
          </custom-table-cell>
          <custom-table-cell align="left" vertical-align="center">
            {{ props.row.resident_name }}
          </custom-table-cell>
          <custom-table-cell align="left" vertical-align="center">
            <Clickable
              class="tw-text-left"
              @click="() => openResidentialSettings(props.row)"
            >
              {{ props.row.project_name }}
            </Clickable>
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            <div
              class="tw-flex tw-items-center tw-justify-center tw-gap-1"
            >
              {{ props.row.floor_map_document_id }}
              <q-icon
                v-if="props.row.is_manually_created"
                name="info"
                size="16px"
                color="primary"
                style="cursor: pointer;"
              >
                <q-tooltip>
                  Создан вручную<br />
                  <span v-if="props.row.manually_fio"
                    >ФИО: {{ props.row.manually_fio }}</span
                  >
                </q-tooltip>
              </q-icon>
            </div>
          </custom-table-cell>
          <custom-table-cell align="left" vertical-align="center">
            {{ props.row.floor_map_document_type_name }}
          </custom-table-cell>
          <custom-table-cell align="left" vertical-align="center">
            {{ props.row.work_set_check_group_name }}
          </custom-table-cell>
          <custom-table-cell align="left" vertical-align="center">
            {{ props.row.placement_type_name }}
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            {{ props.row.block_name }}
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            {{ props.row.floor }}
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            {{ props.row.date_create }}
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            <div
              class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1 tw-leading-snug"
            >
              <CheckOrClose :value="props.row.is_pto_checked === true" />
              <template v-if="props.row.is_pto_checked">
                <span
                  v-if="props.row.pto_accepted_at"
                  class="tw-text-xs tw-text-grey-8"
                  >{{ props.row.pto_accepted_at }}</span
                >
                <span v-if="props.row.pto_employee_fio" class="tw-text-xs">{{
                  props.row.pto_employee_fio
                }}</span>
              </template>
            </div>
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            <div
              class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1"
            >
              <Clickable
                style="display: flex; align-items: center; gap: 5px;"
                hideUnderline
                :disabled="
                  !!downloadingSigned[props.row.floor_map_document_id] ||
                  !!downloading[props.row.floor_map_document_id]
                "
                @click="
                  () =>
                    props.row.have_signed
                      ? handleDownloadSigned(props.row)
                      : handleClickDoc(props.row)
                "
              >
                <ShinyButton
                  v-if="
                    downloadingSigned[props.row.floor_map_document_id] ||
                    downloading[props.row.floor_map_document_id]
                  "
                  text="Скачать"
                />
                <span v-else>Скачать</span>
                <q-icon name="download" />
              </Clickable>
            </div>
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            <span v-if="!props.row.is_foreman_checked && !props.row.is_pto_checked && props.row.schema_id === 4">Ожидает подписания АСР</span>
            <span v-else-if="!props.row.is_foreman_checked && !props.row.is_pto_checked">Ожидает принятия НУ</span>
            <CustomButton
              v-else-if="!props.row.is_pto_checked"
              outline
              color="primary"
              size="sm"
              padding="sm"
              style="height: 36px; font-size: 13px; white-space: nowrap;"
              :loading="acceptingRowId === props.row.floor_map_document_pre_call_id"
              :disable="
                acceptingBulk ||
                (acceptingRowId !== null &&
                  acceptingRowId !== props.row.floor_map_document_pre_call_id)
              "
              @click="openConfirmSingleAccept(props.row)"
            >
              Принять
            </CustomButton>
          </custom-table-cell>
        </q-tr>
      </template>
    </CustomTable>
  </div>
</template>

<script>
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import CheckOrClose from "@/components/common/CheckOrClose";
import Clickable from "@/components/common/Clickable";
import CustomButton from "@/components/common/CustomButton.vue";
import CustomCheckbox from "@/components/form/CustomCheckbox";
import CustomSelect from "@/components/form/CustomSelect";
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import NotFoundText from "@/components/common/NotFoundText";
import ShinyButton from "@/components/common/ShinyButton";
import { API_URL, MODAL_NAMES, PAGES } from "@/constants";
import { downloadFile } from "@/services";
import { useAppStore } from "@/services/store/app";
import {
  acceptPtoDocumentsSession,
  entranceDocumentPtoColumns,
  getEngineerPtoAssignmentsRead,
  getEntranceDocumentTypes,
  getPtoDocumentsSessionRead,
  ptoDocumentsSessionLocationColumns,
} from "@/views/ResidentialSettings/services";

const PTO_FLOOR_OPTIONS = [
  { floor: "", floor_name: "Все" },
  ...Array.from({ length: 40 }, (_, i) => ({
    floor: i + 1,
    floor_name: String(i + 1),
  })),
];
const PTO_DOCUMENT_STATUS_OPTIONS = [
  { status: "", status_name: "Все" },
  { status: "accept", status_name: "Принять" },
  { status: "wait_nu", status_name: "Ожидает принятие НУ" },
  { status: "accepted", status_name: "Принятый" },
  { status: "wait_asr", status_name: "Ожидает подписания АСР" },
];

export default {
  name: "PtoDocuments",
  components: {
    CheckOrClose,
    Clickable,
    CustomButton,
    CustomCheckbox,
    CustomSelect,
    CustomTable,
    CustomTableCell,
    NotFoundText,
    ShinyButton,
  },
  data() {
    return {
      API_URL,
      rowsData: [],
      assignments: [],
      assignmentsLoaded: false,
      documentTypes: [],
      isFetching: false,
      filters: {
        resident_id: "",
        project_id: "",
        floor: "",
        floor_map_document_type_id: "",
        status: "accept",
      },
      selectedItems: [],
      downloading: {},
      downloadingSigned: {},
      acceptingBulk: false,
      acceptingRowId: null,
    };
  },
  computed: {
    tableColumns() {
      return [
        ...ptoDocumentsSessionLocationColumns,
        ...entranceDocumentPtoColumns,
      ];
    },
    hasPtoAssignments() {
      return Array.isArray(this.assignments) && this.assignments.length > 0;
    },
    residentOptions() {
      const seen = new Set();
      const list = [{ resident_id: "", resident_name: "Все" }];
      for (const a of this.assignments || []) {
        if (a.resident_id == null || seen.has(a.resident_id)) continue;
        seen.add(a.resident_id);
        list.push({
          resident_id: a.resident_id,
          resident_name: a.resident_name || "",
        });
      }
      return list;
    },
    projectOptions() {
      const list = [{ project_id: "", project_name: "Все" }];
      const rid = this.filters.resident_id;
      const seen = new Set();
      for (const a of this.assignments || []) {
        if (rid !== "" && rid != null && a.resident_id !== rid) continue;
        if (a.project_id == null || seen.has(a.project_id)) continue;
        seen.add(a.project_id);
        list.push({
          project_id: a.project_id,
          project_name: a.project_name || "",
        });
      }
      return list;
    },
    ptoFloorOptions() {
      return PTO_FLOOR_OPTIONS;
    },
    ptoDocumentStatusOptions() {
      return PTO_DOCUMENT_STATUS_OPTIONS;
    },
    isAllSelected() {
      const sel = this.rowsData.filter((r) => !r.is_pto_checked);
      if (sel.length === 0) return false;
      return sel.every((r) =>
        this.selectedItems.includes(r.floor_map_document_pre_call_id)
      );
    },
    isIndeterminate() {
      const sel = this.rowsData.filter((r) => !r.is_pto_checked);
      if (sel.length === 0) return false;
      const n = sel.filter((r) =>
        this.selectedItems.includes(r.floor_map_document_pre_call_id)
      ).length;
      return n > 0 && n < sel.length;
    },
  },
  watch: {
    rowsData() {
      this.syncSelection();
    },
  },
  methods: {
    syncSelection() {
      this.selectedItems = this.selectedItems.filter((id) =>
        this.rowsData.some((r) => r.floor_map_document_pre_call_id === id)
      );
    },
    toggleSelectAll(val) {
      const sel = this.rowsData.filter((r) => !r.is_pto_checked);
      if (val) {
        const ids = sel.map((r) => r.floor_map_document_pre_call_id);
        this.selectedItems = [...new Set([...this.selectedItems, ...ids])];
      } else {
        const drop = new Set(sel.map((r) => r.floor_map_document_pre_call_id));
        this.selectedItems = this.selectedItems.filter((id) => !drop.has(id));
      }
    },
    toggleItem(row, val) {
      const id = row.floor_map_document_pre_call_id;
      const i = this.selectedItems.indexOf(id);
      if (val) {
        if (i === -1) this.selectedItems.push(id);
      } else if (i > -1) this.selectedItems.splice(i, 1);
    },
    isItemSelected(row) {
      return this.selectedItems.includes(row.floor_map_document_pre_call_id);
    },
    onFilterChange(key, value) {
      this.filters[key] = value;
      if (key === "resident_id") {
        this.filters.project_id = "";
      }
      this.loadData();
    },
    queryParams() {
      const p = {};
      if (this.filters.resident_id !== "" && this.filters.resident_id != null) {
        p.resident_id = this.filters.resident_id;
      }
      if (this.filters.project_id !== "" && this.filters.project_id != null) {
        p.project_id = this.filters.project_id;
      }
      if (this.filters.floor !== "" && this.filters.floor != null) {
        p.floor = this.filters.floor;
      }
      if (
        this.filters.floor_map_document_type_id !== "" &&
        this.filters.floor_map_document_type_id != null
      ) {
        p.floor_map_document_type_id = this.filters.floor_map_document_type_id;
      }
      if (this.filters.status !== "" && this.filters.status != null) {
        p.status = this.filters.status;
      }
      return p;
    },
    async loadAssignments() {
      const res = await getEngineerPtoAssignmentsRead();
      this.assignmentsLoaded = true;
      if (res === undefined) return;
      this.assignments = res;
    },
    async loadDocumentTypes() {
      const res = await getEntranceDocumentTypes();
      this.documentTypes = [{ floor_map_document_type_id: "", floor_map_document_type_name: "Все" }, ...(res || [])];
    },
    async loadData() {
      if (!this.hasPtoAssignments) {
        this.rowsData = [];
        return;
      }
      this.isFetching = true;
      const res = await getPtoDocumentsSessionRead(this.queryParams());
      this.isFetching = false;
      if (res === undefined) return;
      this.rowsData = res;
    },
    openResidentialSettings(row) {
      const qs = new URLSearchParams({
        resident_id: String(row.resident_id ?? ""),
        project_type_id: String(row.project_type_id ?? ""),
        project_entrance_id: String(row.project_entrance_id ?? ""),
        project_id: String(row.project_id ?? ""),
        tab: "M__ProjectFormDocumentTab",
      });
      const url = `${window.location.origin}${PAGES.residentialSettings}?${qs.toString()}`;
      window.open(url, "_blank", "noopener,noreferrer");
    },
    async handleClickDoc(doc) {
      const id = doc.floor_map_document_id;
      if (this.downloading[id]) return;
      this.downloading[id] = true;
      await downloadFile(
        doc.master_url,
        `${doc.floor_map_document_type_name}${doc.document_date ? ` - ${doc.document_date}` : ""}`,
        {},
        doc.file_ext || "pdf",
        "get",
        false
      );
      this.downloading[id] = false;
    },
    async handleDownloadSigned(row) {
      const floor_map_document_id = row.floor_map_document_id;
      if (this.downloadingSigned[floor_map_document_id]) return;
      const url = `${API_URL}/project/documents/signed/download/`;
      const fileName = row.floor_map_document_type_name
        ? `${row.floor_map_document_type_name}${row.document_date ? ` - ${row.document_date}` : ""}`
        : "Подписанный документ.pdf";
      this.downloadingSigned[floor_map_document_id] = true;
      await downloadFile(
        url,
        fileName,
        { floor_map_document_id },
        "pdf",
        "post",
        false,
        {}
      );
      this.downloadingSigned[floor_map_document_id] = false;
    },
    openConfirmBulkAccept() {
      if (this.selectedItems.length === 0) {
        this.showErrorSnackbar("Не выбрано ни одного документа");
        return;
      }
      this.showModal(MODAL_NAMES.CONFIRM, {
        title: "Принять исполнительные схемы",
        message: `Будет принято документов: ${this.selectedItems.length}. Продолжить?`,
        btnText: "Принять",
        cancelBtnText: "Отмена",
        onSubmit: async () => {
          this.acceptingBulk = true;
          const res = await acceptPtoDocumentsSession({
            floor_map_document_pre_call_ids: this.selectedItems,
          });
          this.acceptingBulk = false;
          if (!res) return;
          this.closeModal();
          this.selectedItems = [];
          await this.loadData();
          this.showSucceedSnackbar("Документы приняты");
        },
      });
    },
    openConfirmSingleAccept(row) {
      const preCallId = row?.floor_map_document_pre_call_id;
      if (preCallId == null || row?.is_pto_checked) return;
      this.showModal(MODAL_NAMES.CONFIRM, {
        title: "Принять исполнительную схему",
        message: "Принять этот документ?",
        btnText: "Принять",
        cancelBtnText: "Отмена",
        onSubmit: async () => {
          this.acceptingRowId = preCallId;
          const res = await acceptPtoDocumentsSession({
            floor_map_document_pre_call_ids: [preCallId],
          });
          this.acceptingRowId = null;
          if (!res) return;
          this.closeModal();
          await this.loadData();
          this.showSucceedSnackbar("Документ принят");
        },
      });
    },
  },
  setup() {
    const { showModal, closeModal } = useAppStore();
    const { showSucceedSnackbar, showErrorSnackbar } = useCustomSnackbar();
    return {
      showModal,
      closeModal,
      showSucceedSnackbar,
      showErrorSnackbar,
    };
  },
  async mounted() {
    await this.loadAssignments();
    await this.loadDocumentTypes();
    await this.loadData();
  },
};
</script>

<style scoped lang="scss">
.pto-documents {
  max-width: 100%;
}
</style>
